// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1_M1Q","requiredAsterisk":"Info_requiredAsterisk__2EL7q"};